import { render, staticRenderFns } from "./ModifyPaymentPreference.vue?vue&type=template&id=5cdcc3f5&"
import script from "./ModifyPaymentPreference.vue?vue&type=script&lang=js&"
export * from "./ModifyPaymentPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports